/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".tool-panel[_ngcontent-%COMP%]{background-color:#eee;position:relative}.tool-panel[_ngcontent-%COMP%]   .tool-button[_ngcontent-%COMP%]{margin:4px}.tool-panel[_ngcontent-%COMP%]   .tool-button[_ngcontent-%COMP%]:hover{cursor:pointer}.tool-panel[_ngcontent-%COMP%]   .tool-button.is-checked[_ngcontent-%COMP%]{background-color:#d0d0d0}"];
export { styles as styles };
